import { AvatarV2 } from '@cimplico/components';
import { UserOverview } from '../../types/user';
import { calcRelativeTime } from '../../utilities/formatting';

type AuthorProps = {
    /**
     * User who created the comment/query/note
     */
    createdBy: UserOverview;
    /**
     * Timestamp when the comment/query/note is created
     */
    createdAt: Date;
};

/**
 * Author section at the top left corner of the card
 */
function Author({ createdBy, createdAt }: AuthorProps): JSX.Element {
    return (
        <div className="flex items-start gap-2">
            <span className="shrink-0">
                <AvatarV2
                    color={createdBy.profileHexColour}
                    alt={`${createdBy.firstName[0]}${createdBy.lastName[0]}`.toUpperCase()}
                    src={createdBy.avatarUrl}
                    size="xs"
                />
            </span>
            <div className="flex flex-col justify-center items-start">
                <p className="text-sm text-gray-800 font-medium">
                    {createdBy.firstName} {createdBy.lastName}
                </p>
                <label className="text-xs text-gray-600">{calcRelativeTime(createdAt, true)}</label>
            </div>
        </div>
    );
}

export default Author;
